import script from "./EventsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventsList.vue?vue&type=script&lang=ts&setup=true"

import "./EventsList.vue?vue&type=style&index=0&id=250d14d6&lang=css"

const __exports__ = script;

export default __exports__